import { customBaseQuery } from '@/lib/baseQuery';
import { ApiResponse, OaSheetDataType } from '@/shared/types';
import { createApi } from '@reduxjs/toolkit/query/react';

export interface SheetUpdateDto {
  range: string;
  values: any[][];
}

export interface BatchUpdateSheetCellsDto {
  spreadsheetId: string;
  updates: SheetUpdateDto[];
}

export interface GSheetBatchUpdateResponse {
  success: boolean;
  message: string;
}

export interface FxRate {
  from: string;
  to: string;
  rate: number;
}

export interface FxOption {
  label: string;
  value: string;
}

export interface FxRatesData {
  rates: FxRate[];
  selectedConversion: FxRate;
}
export interface GetFxRatesArgs {
  range?: string; // e.g. 'FX!A1:C42' (optional; backend has a default)
}

export const gSheetAPI = createApi({
  reducerPath: 'gSheetAPI',
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    gSheetBatchUpdate: builder.mutation<
      ApiResponse<GSheetBatchUpdateResponse>,
      BatchUpdateSheetCellsDto
    >({
      query: (body) => ({
        url: 'google-sheet/batch-update',
        method: 'POST',
        body,
      }),
    }),
    getOaSheetData: builder.query<ApiResponse<OaSheetDataType>, string>({
      query: (sheetId) => {
        const searchParams = new URLSearchParams({
          sheetId: sheetId,
        });
        return {
          url: `/google-sheet/OA?${searchParams.toString()}`,
        };
      },
    }),
    getFxRatesFromGsheet: builder.query<
      ApiResponse<FxRatesData>,
      GetFxRatesArgs | void
    >({
      query: (args) => {
        const searchParams = new URLSearchParams();

        if (args?.range) {
          searchParams.set('range', args.range);
        }

        const qs = searchParams.toString();
        return {
          url: `/google-sheet/fx${qs ? `?${qs}` : ''}`,
        };
      },
    }),
  }),
});

export const {
  useGSheetBatchUpdateMutation,
  useGetOaSheetDataQuery,
  useGetFxRatesFromGsheetQuery,
} = gSheetAPI;
